import * as React from 'react';
import { FunctionField, useNotify } from 'react-admin';
import { Button } from '@mui/material';

const TextCopyField = ( {label, source, ...props} ) => {
    const notify = useNotify();
    return (
        <FunctionField {...props}
            label={label}
            render={
                record => (
                    <>
                        <span>{record[source]}</span>
                        <Button color="secondary" size="small"
                            onClick={
                                () => navigator.clipboard.writeText(record[source]).then(() => notify(`Copy "${record[source]}" to clipboard`))
                            }>
                            Copy
                        </Button>
                    </>
                )
            }
        />
    )
}

export default TextCopyField